/**
 * @description 检查api版本
 * @returns {boolean}
 */
export const apiVersionCheck = (targetVersion = 2) => {
  const defaultApiVersion = 1;
  let apiVersion = window.$apiVersion === undefined ? defaultApiVersion : window.$apiVersion;
  if (localStorage.getItem('$apiVersion')) {
    apiVersion = parseInt(localStorage.getItem('$apiVersion'));
  }
  return apiVersion >= targetVersion;
}
